interface CustomRadioProps {
  name: string;
  value: string;
  label: string;
  checked: boolean;
  onChange: () => void;
}

export const CustomRadio = ({
  name,
  value,
  label,
  checked,
  onChange,
}: CustomRadioProps) => (
  <div className="inline-flex items-center gap-1.5 px-1 py-0.5 rounded-lg transition-colors hover:bg-gray-50 cursor-pointer">
    <label
      className="relative flex items-center p-2 rounded-full cursor-pointer"
      htmlFor={`${name}-${value}`}
    >
      <input
        type="radio"
        name={name}
        id={`${name}-${value}`}
        value={value}
        className="before:content[''] peer relative h-[18px] w-[18px] cursor-pointer appearance-none rounded-full border border-gray-300 text-primary transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:border-gray-500 before:bg-transparent before:opacity-0 before:transition-opacity checked:border-primary checked:before:bg-primary hover:border-gray-400 hover:before:opacity-10"
        checked={checked}
        onChange={onChange}
      />
      <span className="absolute text-primary transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <circle data-name="ellipse" cx="8" cy="8" r="8" />
        </svg>
      </span>
    </label>
    <label
      htmlFor={`${name}-${value}`}
      className="text-sm font-medium text-gray-600 cursor-pointer hover:text-gray-900 transition-colors"
    >
      {label}
    </label>
  </div>
);
